import auth from './actions/auth';
import application from './actions/application';
import modal from './actions/modal';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...auth,
  ...modal,
  ...application,
};
